import _ from 'underscore'
import Backbone from 'backbone'
import TextTemplate from '../templates/text.tpl'

const NoUserView = Backbone.View.extend({
    tagName: 'li',
    id: 'no-user-view',
    initialize() {
        this.template = _.template(TextTemplate)
    },
    render() {
        this.$el.html(this.template({text: 'No Users'}))
        return this
    }
})

export default NoUserView
